export default __webpack_public_path__ + "static/media/388.ce1d5809.png";